import React from 'react';
import { Chapter } from '../types';

// Renders the "In This Guide" index. No lesson currently ships chapters — the
// prototype suppresses them for the two adopted-pet guides — but the shape is
// fixed, so this stays wired for future guides.
export default function ChapterIndex({ chapters }: { chapters: Chapter[] }) {
  if (!chapters.length) return null;
  return (
    <section className="pc-lesson-card">
      <h2 className="pc-lesson-card-title">In This Guide</h2>
      <ol className="pc-lesson-chapters">
        {chapters.map((ch) => (
          <li className="pc-lesson-chapter" key={ch.num}>
            <span className="pc-lesson-chapter-num">{ch.num}</span>
            <span className="pc-lesson-chapter-label">{ch.label}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
